import * as t from 'io-ts'

import { optional } from '@root/utils/types'
import { FacescanPrivacyDecoder, RegionDecoder } from './config'

export const LightConfigCodec = t.type({
  /**
   * The CSS selector of the element in which the widget will be printed
   */
  selector: t.string,

  /**
   * The language of the widget (if not present, there is a fallback on English)
   *
   * @default: en-US
   */
  locale: t.string,

  /**
   * Hide gender (Your Style) property on FA light version
   * by default is false
   */
  hideGender: optional(t.boolean),

  /**
   * The source of the facescan integration
   *
   * Possible values:
   * - FASA_RBCOM
   * - FASA_OOCOM
   * - FASA_SGHCOM
   * - FASA_LCCOM
   * - FASA_GLASSESCOM
   * - FASA_COSTACOM
   *
   */
  facescanSource: t.string,

  /**
   * The region of the e-commerce integration - used by facescan app
   *
   * Possible values:
   * - US
   * - EU
   * - AU
   *
   */
  facescanRegion: RegionDecoder,

  /**
   * Privacy policy propertires used by facescan app
   */
  facescanPrivacy: FacescanPrivacyDecoder,

  /**
   * The key of Virtual Mirror Component
   *
   */
  frameAdvKey: t.string,

  /**
   * Brand name to be used on the Privacy Policy modal
   *
   */
  privacyPolicyBrandName: optional(t.string),

  /**
   * The absolute path of the language file in json format
   *
   */
  overrideTranslationsUrl: optional(t.string),

  /**
   * Title shown on onboarding
   *
   */
  onboardingTitle: optional(t.string),

  /**
   * This property is used to override default CMS API to Test.
   * by default is false
   */
  isTestCMS: optional(t.boolean),

  debug: optional(t.boolean),

  debugMeasurement: optional(t.boolean),

  resetProfileDataCallback: optional(t.Function),
  onBack: optional(t.Function),
  onContinue: optional(t.Function),
})

type LightConfigCallbacks = {
  /** This function is used to reset the user profie information outside the app */
  resetProfileDataCallback?: (userId: string) => Promise<void>
}

export type LightConfig = t.TypeOf<typeof LightConfigCodec>

export type LightConfigWithCallbacks = LightConfig & LightConfigCallbacks
